import { Theme } from '@mui/material';

export const navbar = {
  display: 'flex',
  minHeight: { xs: '66px', md: '66px' },
  maxHeigth: { xs: '66px', md: '66px' },
};

export const appBar = (theme: Theme) => ({
  padding: '10px 0',
  background: theme.palette.elevation01?.main,
  boxShadow: 0,
  zIndex: 2,
});

export const toolBar = {
  display: 'flex',
  justifyContent: 'space-between',
  boxSizing: 'border-box',
  minHeight: { xs: '62px', md: '62px' },
  maxHeigth: { xs: '62px', md: '62px' },
};

export const companyContainer = { display: 'flex' };

export const titleContainer = {
  display: 'flex',
  alignItems: 'center',
  paddingLeft: '14px',
};

export const title = (theme: Theme) => ({
  color: theme.palette.text.primary,
  fontSize: 14,
  textAlign: 'left',
});

export const btnContainer = { width: { xs: 'auto', md: '100px' } };

export const btnIcon = (theme: Theme) => ({
  cursor: 'pointer',
  borderRadius: '8px',
  width: { xs: '50px', md: '80px' },
  height: '40px',
  justifyContent: 'center',
  alignItems: 'center',
  ':hover': {
    bgcolor: theme.palette.hover?.main,
  },
  border: '1px solid #ccc!important',
  display: 'flex',
});

export const langTitle = (theme: Theme) => ({
  fontSize: '16px',
  fontWeight: '400',
  color: theme.palette.text.primary,
  paddingLeft: '10px',
});
